import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {TypedSimpleChanges} from '../../../common/typed-on-changes';
import {WidgetLinkingGroupId} from '../../../enums/widget-linking-group';
import {
    DisplayWidgetLinkingGroup,
    DisplayWidgetLinkingGroupFactory
} from '../../../factories/display-widget-linking-group.factory';
import {ModalService} from '../../modal';
import {WidgetLinkingGroupDropdownComponent} from './widget-linking-group-dropdown';

@Component({
    selector: 'widget-linking-group-picker',
    templateUrl: './widget-linking-group-picker.component.html',
    styleUrls: ['./widget-linking-group-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetLinkingGroupPickerComponent implements OnInit, OnChanges {

    @Input()
    public widgetLinkingGroupId: WidgetLinkingGroupId;

    @Input()
    public targetElementForDropdownMenu: ElementRef;

    @Output()
    public widgetLinkingGroupIdChange = new EventEmitter<WidgetLinkingGroupId>();

    public widgetGroupLinkingDropdownComponent: WidgetLinkingGroupDropdownComponent;
    public WidgetLinkingGroupId = WidgetLinkingGroupId;
    public linkingGroups: DisplayWidgetLinkingGroup[];
    public selectedLinkingGroup: DisplayWidgetLinkingGroup;

    constructor(
        private modalService: ModalService
    ) {}

    public ngOnInit(): void {
        this.linkingGroups = DisplayWidgetLinkingGroupFactory.getDisplayWidgetLinkingGroups();
    }

    public ngOnChanges(changes: TypedSimpleChanges<WidgetLinkingGroupPickerComponent>): void {
        if (changes.widgetLinkingGroupId) {
            const type = this.widgetLinkingGroupId;
            this.selectedLinkingGroup = DisplayWidgetLinkingGroupFactory.getDisplayWidgetLinkingGroupByType(type);
        }
    }

    public openDropdownMenu(): void {
        this.widgetGroupLinkingDropdownComponent = this.modalService.open(WidgetLinkingGroupDropdownComponent, {
            configure: {
                targetElement: this.targetElementForDropdownMenu,

                widgetLinkingGroupId: this.widgetLinkingGroupId,

                onCloseCallback: (selectedLinkingGroup?: DisplayWidgetLinkingGroup) => {
                    if (selectedLinkingGroup) {
                        this.selectedLinkingGroup = selectedLinkingGroup;
                        this.widgetLinkingGroupIdChange.emit(selectedLinkingGroup.id);
                    }

                    this.widgetGroupLinkingDropdownComponent = null;
                }
            }
        }).instance;
    }
}
